import { defineComponent as L, ref as g, computed as o, watchEffect as j, openBlock as u, createBlock as p, Transition as T, withCtx as k, withDirectives as S, createElementVNode as b, unref as i, createVNode as c, createCommentVNode as h, vShow as M } from "vue";
import { DefaultStep as d, DeviceKind as A, ToolModuleKind as a, ToolLayoutKind as E } from "@thehotelsnetwork/personalization-types";
import { u as F, b as P, j as H, c as O, k as q, m as $, f as z, e as G, t as J } from "./popup.es.js";
import "tinycolor2";
import "@vueuse/core";
import "@thehotelsnetwork/icons/vue/linear";
const Q = ["data-device"], ee = /* @__PURE__ */ L({
  __name: "LowerNotification",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(C, { expose: D }) {
    const t = C, s = F(), m = g(!1), x = g(), N = o(() => (s == null ? void 0 : s.handlers.stepActive) || d.Main), n = o(() => (s == null ? void 0 : s.literals.device) === A.Mobile), y = o(() => t.steps[d.Main].filter(
      (e) => e.moduleType !== a.Icon
    ).length), f = o(() => t.steps[d.Main].find(
      (e) => e.moduleType === a.Icon
    )), v = o(() => t.steps[N.value].find(
      (e) => e.moduleType === a.Button
    )), w = o(() => !!t.steps[d.Main].find(
      (e) => e.moduleType === a.Form
    )), B = o(() => Object.keys(t.steps).reduce((_, l) => (_[l] = t.steps[l].filter(
      (r) => r.moduleType !== a.Icon && r.moduleType !== a.Button || r.moduleType !== a.Icon && y.value > 4 || r.moduleType !== a.Icon && w.value || n.value
    ), _), {})), I = o(() => {
      if (x.value)
        return n.value ? 0 : 270;
    });
    j(() => {
      s == null || s.styles.addCssVariables(
        n.value ? {
          "--step-padding": "5px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--module-margin-top": "10px",
          "--step-padding": `5px 15px 10px ${f.value ? 20 : 0}px`,
          "--xclose-margin": "7px"
        }
      );
    });
    function V() {
      m.value = !1;
    }
    function K() {
      m.value = !0;
    }
    return D({
      show: V,
      hide: K
    }), (e, _) => (u(), p(T, {
      name: "fade-from-bottom",
      appear: ""
    }, {
      default: k(() => {
        var l;
        return [
          S(b("div", {
            class: "thn--tool-lower-notification",
            ref_key: "rootDom",
            ref: x
          }, [
            b("div", {
              class: "thn--tool-lower-notification__popup",
              "data-device": (l = i(s)) == null ? void 0 : l.literals.device
            }, [
              c(P, { class: "thn--tool-lower-notification__back" }),
              f.value && !n.value ? (u(), p(H, {
                key: 0,
                class: "thn--tool-lower-notification__icon",
                "module-props": f.value
              }, null, 8, ["module-props"])) : h("", !0),
              c(O, {
                class: "thn--tool-lower-notification__steps",
                steps: B.value,
                "has-extra-steps": t.hasSteps,
                "max-height": I.value,
                "layout-kind": i(E).LowerNotification
              }, null, 8, ["steps", "has-extra-steps", "max-height", "layout-kind"]),
              v.value && !n.value && y.value <= 4 && !w.value ? (u(), p(q, {
                key: 1,
                class: "thn--tool-lower-notification__button",
                "module-props": v.value,
                "has-extra-steps": t.hasSteps,
                "data-module-id": v.value.id,
                "data-module-special": !0
              }, null, 8, ["module-props", "has-extra-steps", "data-module-id"])) : h("", !0),
              i($) ? h("", !0) : (u(), p(z, {
                key: 2,
                class: "thn--tool-lower-notification__xclose"
              })),
              c(T, { name: "fade" }, {
                default: k(() => [
                  S(c(G, { "terms-text": i(J) }, null, 8, ["terms-text"]), [
                    [M, i($)]
                  ])
                ]),
                _: 1
              })
            ], 8, Q)
          ], 512), [
            [M, !m.value]
          ])
        ];
      }),
      _: 1
    }));
  }
});
export {
  ee as default
};
//# sourceMappingURL=popup-p-components-LowerNotification.js.map
